<template>
  <div class="container-field">
    <h3>Variáveis</h3>

    <b-table-simple>
      <b-thead>
        <b-tr>
          <b-th v-for="field in fields" :key="field.key">
            {{ field.label }}
          </b-th>
        </b-tr>
      </b-thead>
      <b-tbody>
        <template v-for="row in variables">
          <b-tr :key="row.id" v-if="row.active">
            <b-td>
              <b-button variant="danger" size="sm" @click="removeVariable(row)"
                >X</b-button
              >
            </b-td>
            <b-td>
              <b-form-input
                class="input-name"
                type="text"
                v-model="row.variableName"
                required
              />
            </b-td>
            <b-td>
              <b-form-select
                class="select-field"
                :options="optionsVariableType"
                v-model="row.variableType"
              ></b-form-select>
            </b-td>
            <b-td>
              <b-form-select
                v-if="row.variableType == 0"
                class="select-field"
                :options="companyOptions"
                v-model="row.fieldType"
              ></b-form-select>
            </b-td>
            <b-td>
              <b-form-select
                :options="optionsBool"
                v-model="row.currentForm"
              ></b-form-select>
            </b-td>
          </b-tr>
        </template>
      </b-tbody>
    </b-table-simple>

    <b-button size="sm" @click="newVariable">Nova variável</b-button>
  </div>
</template>
<script>
export default {
  name: "PredefinedScriptVariableCrud",
  props: {
    variables: Array,
    companyOptions: Array,
  },
  data() {
    return {
      optionsBool: [
        { value: true, text: "Sim" },
        { value: false, text: "Não" },
      ],
      optionsVariableType: [
        { value: 0, text: "Campo" },
        { value: 1, text: "Formulário" },
      ],
      fields: [
        {
          key: "actions",
          filterKey: "actions",
          label: "",
          sortable: true,
          tdClass: "nowrapActions",
        },
        {
          key: "variableName",
          filterKey: "variableName",
          label: "Nome",
          thStyle: "min-width: 350px;",
          sortable: true,
        },
        {
          key: "variableType",
          filterKey: "variableType",
          label: "Tipo da variável",
          sortable: true,
        },
        {
          key: "fieldType",
          filterKey: "fieldType",
          label: "Tipo do campo",
          thStyle: "max-width: 50px;",
          sortable: true,
        },
        {
          key: "currentForm",
          filterKey: "currentForm",
          label: "Formulário atual",
          sortable: true,
        },
      ],
    };
  },
  methods: {
    newVariable() {
      let variable = {
        id: 0,
        active: true,
        variableName: "",
        fieldType: 6,
        formName: "",
        currentForm: true,
        variableType: 0,
      };
      this.variables.push(variable);
    },
    removeVariable(row) {
      if (row.id == 0) {
        let rowIndex = this.variables.indexOf(row);
        if (rowIndex >= 0) {
          this.variables.splice(rowIndex, 1);
        }
      } else {
        row.active = false;
      }
    },
  },
};
</script>
<style>
.input-name {
  min-width: 500px;
}
.select-field {
  min-width: 100px;
}
</style>

